import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export default [
    {
        type: AgGridColumnType.TEXT,
        headerName: i18n.tc('laboratory.tracking.report.subportionId'),
        field: 'supLabel'
    },
    {
        type: AgGridColumnType.TEXT,
        headerName: i18n.tc('laboratory.tracking.report.topographicCode'),
        field: 'portion.sample.topographicCode.description'
    },
    {
        type: AgGridColumnType.TEXT,
        headerName: i18n.tc('laboratory.tracking.report.assay'),
        field: 'assay.name'
    },
    {
        type: AgGridColumnType.TEXT,
        headerName: i18n.tc('laboratory.tracking.report.requester'),
        field: 'requester.fullName'
    },
    {
        type: AgGridColumnType.TEXT,
        headerName: i18n.tc('laboratory.tracking.report.pathologist'),
        field: 'portion.sample.caseStudy.pathologist.fullName'
    },
    {
        type: AgGridColumnType.NUMBER,
        headerName: i18n.tc('laboratory.tracking.report.priorityLevel'),
        field: 'priority.level'
    }
]
